export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo1-71ebd8470b831daf064df85e1e96927f.jpg";